import axios from "./authWrapper";
import { BASE_URL } from "../config";

export async function workspaceRequest(
  landlordId,
  path = "",
  { method = "GET", data, signal } = {},
) {
  const response = await axios({
    url: `${BASE_URL}/admin/landlords/${encodeURIComponent(landlordId)}/workspaces${path}`,
    method,
    data,
    signal,
    headers: { "x-access-token": localStorage.getItem("token") },
  });
  return response.data.success_res;
}

export function workspaceError(error) {
  const message = error?.response?.data?.message;
  return typeof message === "string"
    ? message
    : message?.key || "Unable to save workspace. Please try again.";
}
